import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';

interface AdminAuthState {
    nameidentifier: string | null;
    sub: string | null;
    email: string | null;
    jti: string | null;
    ContactNo: string | null;
    RoleID: string | null;
    RoleName: string | null;
    FirstName: string | null;
    LastName: string | null;
    aud: string | null;  // Added the 'aud' field
    token: string | null;
    isAuthenticated: boolean;
}

const storedToken = localStorage.getItem('crmtoken');

let initialState: AdminAuthState = {
    nameidentifier: null,
    sub: null,
    email: null,
    jti: null,
    ContactNo: null,
    RoleID: null,
    RoleName: null,
    FirstName: null,
    LastName: null,
    aud: null,  // Initialize 'aud' with null
    token: storedToken,
    isAuthenticated: false,
};

if (storedToken) {
    try {
        const decodedToken: any = jwtDecode(storedToken);
        initialState = {
            ...initialState,
            nameidentifier: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
            sub: decodedToken['sub'],
            email: decodedToken['email'],
            jti: decodedToken['jti'],
            ContactNo: decodedToken['ContactNo'],
            RoleID: decodedToken['RoleID'],
            RoleName: decodedToken['RoleName'],
            FirstName: decodedToken['FirstName'],
            LastName: decodedToken['LastName'],
            aud: decodedToken['aud'],  // Store 'aud' from the token
            isAuthenticated: true,
        };
    } catch (error) {
        console.error('Token decoding failed', error);
    }
}

const adminAuthSlice = createSlice({
    name: 'adminAuth',
    initialState,
    reducers: {
        setAdminData: (state, action: PayloadAction<any>) => {
            const { nameidentifier, sub, email, jti, ContactNo, RoleID, RoleName, FirstName, LastName, aud, token } = action.payload;
            state.nameidentifier = nameidentifier;
            state.sub = sub;
            state.email = email;
            state.jti = jti;
            state.ContactNo = ContactNo;
            state.RoleID = RoleID;
            state.RoleName = RoleName;
            state.FirstName = FirstName;
            state.LastName = LastName;
            state.aud = aud;  // Set 'aud' in state
            state.token = token;
            state.isAuthenticated = true;

            // Store token in localStorage
            localStorage.setItem('crmtoken', token);
        },
        logout: (state) => {
            state.nameidentifier = null;
            state.sub = null;
            state.email = null;
            state.jti = null;
            state.ContactNo = null;
            state.RoleID = null;
            state.RoleName = null;
            state.FirstName = null;
            state.LastName = null;
            state.aud = null;  // Clear 'aud' on logout
            state.token = null;
            state.isAuthenticated = false;
            localStorage.removeItem('crmtoken');
        },
    },
});

export const { setAdminData, logout } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
